import script from "./BulletinII.vue?vue&type=script&setup=true&lang=js"
export * from "./BulletinII.vue?vue&type=script&setup=true&lang=js"

import "./BulletinII.vue?vue&type=style&index=0&id=7e3b44a8&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enpzjpl/zjpl-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e3b44a8"]])

export default __exports__